import { render, staticRenderFns } from "./createFolderSidebar.vue?vue&type=template&id=a77998ac&"
import script from "./createFolderSidebar.vue?vue&type=script&lang=js&"
export * from "./createFolderSidebar.vue?vue&type=script&lang=js&"
import style0 from "./createFolderSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports